import type { FaireProductEntity } from "../../entity_types/product";

export const p_69lsb7ocy7: FaireProductEntity = {
  token: "p_69lsb7ocy7",
  type: "product",
  name: "Chocolate Caramel Pecan 1/2 lb. Fudge Bar",
  brandToken: "b_5021dx08mu",
  brandName: "Valley Fudge & Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/8a302795ebba0848ad1566397b78830c79713fc40e1125a396358ea523dc8b66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d86254e281b3ac2390f4999671dfd09b5a5d10c9c5440cf55e732aa9502425f.jpeg",
    "https://cdn.faire.com/fastly/83e48b4098c4f302006c3637196455c923c1a7535f9acc60d560616e01cb2eae.png",
  ],
  priceDollars: 6.86,
  description:
    "Our Fudge is always made with  fresh high quality ingredients, including 100% Real Wisconsin Butter! Pecans and caramel elevate this rich and creamy Chocolate Fudge to an irresistible level. And to top it all off, we add even more pecans and drizzle it with caramel! Is your mouth watering yet? Our mouths sure are!\n\nWholesale Message: To keep it simple and convenient for your business, we sell fudge by the individual package. This means you can purchase as many packages of any flavor as you would like. There is no limit required. The more fudge packages, the merrier!\n\nSale Shelf Life: We make all fudge fresh to order and ship it upon packaging. This provides 7-8 weeks of sale shelf life for your company.\n\nMerchandising Your Fudge: Your fudge is best merchandised at room temperature and out of direct sunlight.\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:47.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
